import React from 'react';
import { MessageCircleIcon, PhoneIcon } from 'lucide-react';
import { contact } from '../data/contact';
export function MobileActionBar() {
  return <div className="sticky top-16 z-30 border-b border-silver/15 bg-carbon/95 px-3 py-2.5 backdrop-blur-md sm:hidden" data-id="element-131" data-mp="auu8hy4rlsmf">
      <div className="flex gap-3" data-id="element-132" data-mp="jtfmrh37elhe">
        <a href={contact.whatsappHref} target="_blank" rel="noreferrer" className="flex min-h-[48px] flex-1 items-center justify-center gap-2 rounded-full border border-accent-soft/30 bg-accent-muted text-[0.72rem] font-medium uppercase tracking-[0.16em] text-frost" aria-label={`Hablar por WhatsApp al ${contact.whatsapp}`} data-id="element-133" data-mp="jtnxp3frngpy">
          <MessageCircleIcon className="h-4 w-4" aria-hidden="true" data-id="element-134" data-mp="v3dzwg7fdmc" />
          WhatsApp
        </a>
        <a href={contact.phoneHref} className="flex min-h-[48px] flex-1 items-center justify-center gap-2 rounded-full border border-silver/35 text-[0.72rem] font-medium uppercase tracking-[0.16em] text-frost" aria-label={`Llamar al ${contact.phone}`} data-id="element-135" data-mp="2zl3jbbeb2bzo">
          <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-136" data-mp="1ahqzigk65ulc" />
          Llamar
        </a>
      </div>
    </div>;
}